import React, {Component} from 'react';
import {folderEdit, folderGet, folderGetByDashboardByUser, folderGetByLevelByUser} from "../requests/Folder";
import FolderTree from "./FolderTree";
import {InteractionTwoTone} from '@ant-design/icons';
import {Modal} from "antd";
import {connect} from "react-redux";
import {updateFolder} from "../../action/action";

class DashboardFolderModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            dashboardFolder: {},
            dashboardFolderID: '',
            modalVisible: false,
            isRefresh: false
        };
        this.handleFolderChange = this.handleFolderChange.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.saveNewDashboard = this.saveNewDashboard.bind(this);
        this.onKeyPress = this.onKeyPress.bind(this);
    }

    handleFolderChange(value) {
        this.setState({dashboardFolderID: value._id});
    }

    updateDashboard = () => {
        folderGetByLevelByUser(this.props.userName, 0, (response) => {
            this.props.updateFolder(response);
        });
    }

    async saveNewDashboard() {
        let {dashboardFolder} = this.state;
        var index = dashboardFolder.charts.indexOf(this.props.dashboardID);
        if (index > -1) {
            dashboardFolder.charts.splice(index, 1);
        }
        folderEdit(dashboardFolder, () => {
            folderGet(this.state.dashboardFolderID, (response2) => {
                dashboardFolder = response2;
                dashboardFolder.charts.push(this.props.dashboardID);
                folderEdit(dashboardFolder, (response3) => {
                    this.setState({
                        dashboardFolder: response3,
                        dashboardFolderID: response3._id,
                        isRefresh: true,
                        modalVisible: false,
                    }, () => {
                        this.updateDashboard();
                        this.setState({modalVisible: false,});
                    });
                    document.removeEventListener("keydown", this.onKeyPress, false);
                }, (error) => {
                    this.props.onError(true);
                    this.setState({modalVisible: false,});
                    document.removeEventListener("keydown", this.onKeyPress, false);
                    console.log(error);
                });
            }, (error) => {
                this.props.onError(true);
                this.setState({modalVisible: false,});
                document.removeEventListener("keydown", this.onKeyPress, false);
                console.log(error);
            });
            this.props.onSuccess(true);
        }, (error) => {
            this.props.onError(true);
            this.setState({modalVisible: false,});
            document.removeEventListener("keydown", this.onKeyPress, false);
            console.log(error);
        });


    }

    showModal = () => {
        this.setState({
            modalVisible: true,
            isRefresh: true
        });
        document.addEventListener("keydown", this.onKeyPress, false);
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.state.modalVisible !== prevState.modalVisible && this.state.modalVisible) {
            folderGetByDashboardByUser(this.props.userName, this.props.dashboardID, (response) => {
                this.setState({dashboardFolder: response, dashboardFolderID: response._id});
            });
        }
    }

    handleCancel = e => {
        this.setState({
            modalVisible: false,
            isRefresh: false
        });
        document.removeEventListener("keydown", this.onKeyPress, false);
    };

    onKeyPress(e) {
        if (e.keyCode === 13) {
            this.saveNewDashboard();
        }
        ;
    }

    updateRefresh = (val) => {
        this.setState({isRefresh: val});
    }

    render() {
        const {dashboardFolderID} = this.state;
        return [
            <div key="md_key" onClick={this.showModal}><InteractionTwoTone/> Move dashboard to
                another folder</div>
            ,
            <Modal key="key_move_DashboardTOAnotherFolder"
                   title="Move this dashboard to another folder"
                   visible={this.state.modalVisible}
                   onOk={this.saveNewDashboard}
                   onCancel={this.handleCancel}
            >

                <div className="mt-4">
                    <span>Choose Destination Folder</span>
                    <FolderTree selectedFolderID={dashboardFolderID} userName={this.props.userName}
                                onChange={this.handleFolderChange} isRefresh={this.state.isRefresh}
                                updateAction={this.updateRefresh}/>
                </div>
            </Modal>
        ];
    }
}

export default (connect(null, {updateFolder})(DashboardFolderModal));
